module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.4.1-109.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.4.1.md
// module id = 526
// module chunks = 293